<template>
	<div id="list-options">
		<div id="list">
			<slot name="list" parentComponentId="list-options__slotList"></slot>
		</div>
		<div id="options" class="optionsWide active">
			<lba-breadcrumb v-if="showBreadcrumb" parentComponentId="list-options__options"></lba-breadcrumb>
			<!-- <lba-history-bar></lba-history-bar> -->
			<div class="page-header">
				<h1><slot name="heading" parentComponentId="list-options__slotHeading"></slot></h1>
				<slot v-if="!getAnyError()" name="controls" parentComponentId="list-options__slotControls"></slot>
			</div>
			<div class="optionsContent">
				<router-view
					v-show="!getAnyError()"
					ref="view"
					:key="routeKey"
					@view-not-found="onError($event, 'notFound')"
					@view-permission-denied="onError($event, 'permissionDenied')"
					@view-server-error="onError($event, 'serverError')"
					@view-record-deleted="onError($event, 'recordDeleted')"
					@view-missing-parameter="onError($event, 'missingParameter')"
					@view-wrong-parameter="onError($event, 'wrongParameter')"
				></router-view>
				<div v-if="getAnyError()" class="error-wrap" data-cy="list-options__options__anyError">
					<h1 v-if="getErrorType() === 'notFound'" data-cy="list-options__options__viewNotFound">
						{{ $t('viewNotFound') }}
					</h1>
					<h1 v-else-if="getErrorType() === 'permissionDenied'" data-cy="list-options__options__viewPermissionDenied">
						{{ $t('viewPermissionDenied') }}
					</h1>
					<h1 v-else-if="getErrorType() === 'serverError'" data-cy="list-options__options__viewServerError">
						{{ $t('viewServerError') }}
					</h1>
					<h1 v-else-if="getErrorType() === 'recordDeleted'" data-cy="list-options__options__viewRecordDeleted">
						{{ getError() || $t('viewRecordDeleted') }}
					</h1>
					<h1 v-else-if="getErrorType() === 'missingParameter'" data-cy="list-options__options__viewMissingParameter">
						{{ $t('viewMissingParameter', { params: getError() }) }}
					</h1>

					<button
						v-if="showReloadButton()"
						type="button"
						@click="reloadPath"
					>
						{{ $t('reload') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import RouteKey from '../mixins/RouteKey';
import TabErrors from '../mixins/TabErrors';

export default {
	mixins: [RouteKey, TabErrors],
	props: {
		showBreadcrumb: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		$route() {
			/* eslint-disable-next-line no-underscore-dangle */
			if (!this._inactive) {
				this.$route.meta.hideBreadcrumb = true;
				this.$root.$emit('route-meta-update');
			}
		},
	},
	created() {
		this.$route.meta.hideBreadcrumb = true;
		this.$root.$emit('route-meta-update');
	},
};
</script>
